<template>
  <el-dialog
    title="已读消息查看"
    class="readmind-div"
    :visible.sync="dialogVisible"
    append-to-body
    width="800px"
  >
    <el-row :gutter="20" type="flex">
      <el-col :span="12">
        <el-date-picker
          size="mini"
          v-model="createtimeRange"
          value-format="yyyy-MM-dd"
          type="daterange"
          align="right"
          unlink-panels
          @change="refershSource"
          range-separator="至"
          class="datePicker"
          format="yyyy 年 MM 月 dd 日"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-col>

      <el-col :span="12">
        <el-input
          size="mini"
          placeholder="请输入关键字模糊搜索"
          v-model="input"
          class="input-with-select"
          @change="refershSource"
        >
          <el-select v-model="inputType" slot="prepend" placeholder="请选择类型">
            <el-option label="任务名" :value="0"></el-option>
            <el-option label="记录名" :value="1"></el-option>
            <el-option label="评论内容" :value="2"></el-option>
          </el-select>
        </el-input>
      </el-col>
    </el-row>
    <el-scrollbar style="height: 400px;width: 100%;margin-top:10px">
      <div>
        <el-card
          @click.native.stop="cardClick(item, index)"
          :class="{ noticePanel: item.active, remindCardInfo: true }"
          v-for="(item, index) in taskNoticeSource"
          :key="index"
        >
          <div class="detailPanel">
            <div class="nameImg">
              <icon :iconClass="getIcon(item.INFOTYPE)" iconStyle="avatarIcon"></icon>
            </div>
            <div>
              <div style="display:flex;flex-wrap: wrap;">
                <!-- <el-tooltip :content="'任务名:'.concat(item.LINKNAME)" placement="bottom" effect="light"> -->
                <el-link
                  class="linkName"
                  v-show="item.LINKNAME && item.LINKNAME.length > 0"
                  :underline="false"
                  @click.native.stop="openTaskDetail(item.LINKID)"
                >
                  <span>【{{ item.LINKNAME }}】</span>
                  <!-- {{item.LINKNAME.length>15?item.LINKNAME.substr(0,15).concat('...'):item.LINKNAME}}】 -->
                </el-link>
                <!-- </el-tooltip> -->
                <el-tooltip :content="item.NAME" placement="bottom" effect="light">
                  <el-link class="title" @click="clickAddress(item)">{{ item.NAME }}</el-link>
                </el-tooltip>
              </div>
              <el-tooltip :content="item.CONTENT" placement="bottom" effect="light">
                <div class="content">{{ item.CONTENT }}</div>
              </el-tooltip>
              <div class="createTime">{{ item.CREATETIME | timeFormater }}</div>
              <!-- <span
                class="reply"
                style="cursor:Pointer"
                @click="reply(item)"
              >{{item.INFOTYPE==102?'回复':'评论'}}</span>-->
            </div>
          </div>
          <!-- <addComment
            v-show="showAddComment&&item.active"
            style="margin:5px;"
            :replyData="replyData"
            @addComment="addSuccess"
            @cancelComment="cancelSuccess"
            :MainId="mainId"
            :Type="mainType"
          ></addComment>-->
        </el-card>
      </div>
    </el-scrollbar>
    <el-row style="margin-top:10px">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @prev-click="handleCurrentChange"
        @next-click="handleCurrentChange"
        :current-page.sync="pageIndex"
        :page-size="pageSize"
        :page-sizes="[10, 30, 50, 100]"
        layout="total, sizes,prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </el-row>
  </el-dialog>
</template>

//已读小提醒

<script>
import { GetReadRemind, GetCrisitismById } from "@/api/modules/basicData/task";
import addComment from "@/components/common/AddComment.vue";
import icon from "@/components/common/icon.vue";
import Vue from "vue";
import { getToken } from "@/util/auth";
const cookieUser = getToken();
export default {
  components: {
    addComment,
    icon,
  },

  watch: {
    dialogVisible(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.loading = true;
          this.pageIndex = 1;
          this.pageSize = 30;
          this.refershSource();
          this.loading = false;
        });
      }
    },
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      taskNoticeSource: [],
      pageIndex: 1,
      pageSize: 30,
      totalCount: 0,
      inputType: 0,
      input: "",
      createtimeRange: [],
      avatarArray: ["gongzuojilu2", "renwutixing", "chat"],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  methods: {
    refershSource() {
      let para = {
        PageIndex: this.pageIndex,
        PageSize: this.pageSize,
        UserId: cookieUser.userId,
        Input: this.input,
        InputSearchStyle: this.inputType,
        RemindState: "1",
      };
      if (this.createtimeRange && this.createtimeRange.length > 0) {
        para.CreateTime1 = this.createtimeRange[0];
        para.CreateTime2 = this.createtimeRange[1];
      }
      console.log(para);
      GetReadRemind(para).then((pageResult) => {
        if (pageResult) {
          this.totalCount = pageResult.TotalItems;
          this.taskNoticeSource = pageResult.Items;
        }
      });
    },
    handleSizeChange() {
      if (!this.loading) this.refershSource();
    },
    handleCurrentChange() {
      if (!this.loading) this.refershSource();
    },
    cardClick(item, index) {
      this.curItem = item;
      console.log(item.INFOTYPE);
      console.log("cardClick", index);
      this.$nextTick(() => {
        this.taskNoticeSource.forEach((o) => {
          Vue.set(o, "active", false);
        });
        Vue.set(item, "active", true);
      });
    },
    getIcon(infotype) {
      switch (infotype) {
        case 118:
          return this.avatarArray[0];
        case 102:
          return this.avatarArray[2];
        default:
          return this.avatarArray[1];
      }
    },
    clickAddress(item) {
      if (!item.ISREAD) {
        ReadRemind([item.ID]).then((result) => {
          if (result > 0) {
            item.ISREAD = true;
            this._refershUnReadState();
          }
        });
      }
      //判断infotype 118工作记录 102 评论
      switch (item.INFOTYPE) {
        case 118: //工作记录
          let url1 = `${location.href.substr(
            0,
            location.href.lastIndexOf("/")
          )}/recordinfo?recordid=${item.RELATIONID}`;
          window.open(url1);
          break;
        case 102: //评论
          GetCrisitismById(item.RELATIONID).then((result) => {
            if (result) {
              this.mainType = result.MAINTYPE;
              this.mainId = result.MAINID;
              this.dialogVisible = true;
            }
          });
          break;
        default:
          let url2 = `${location.href.substr(
            0,
            location.href.lastIndexOf("/")
          )}/task-detailspage?taskid=${item.RELATIONID}`;
          window.open(url2);
          break;
      }
    },
    openTaskDetail(val) {
      var taskId = val;
      if (val.indexOf(",") > 0) {
        var arr = val.split(",");
        taskId = arr[0];
        if (arr[1] == "1") {
          //评论是按逗号隔开的，id,type type=1是工作记录
          let url1 = `${location.href.substr(
            0,
            location.href.lastIndexOf("/")
          )}/recordinfo?recordid=${taskId}`;
          window.open(url1);
          return;
        }
      }
      let url = `${location.href.substr(
        0,
        location.href.lastIndexOf("/")
      )}/task-detailspage?taskid=${taskId}`;
      window.open(url);
    },
  },
};
</script>

<style scoped>
.readmind-div .el-select .el-input {
  width: 100px;
}

.readmind-div .input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style
><style lang="scss" scoped>
.remindCardInfo {
  margin-right: 10px;
}

.remindCardInfo + .remindCardInfo {
  margin-top: 10px;
}

.commonNotice .noticePanel {
  /* box-shadow: 0 2px 12px 0 rgb(32, 179, 45, 0.4); */
  border: 1px dashed gray;
}

.avatarIcon {
  width: 24px;
  height: 24px;
  margin-top: 10px;
}

.readIcon {
  width: 24px;
  height: 24px;
}

.detailPanel {
  display: flex;
  background: white /*beige*/;
}

.title {
  font-size: 14px;
  line-height: 26px;
  margin-left: 6px;
  text-align: left;
  box-sizing: border-box;
  cursor: pointer;
}

.nameImg {
  color: #0c9cdb;
  margin-right: 5px;
}

.linkName {
  color: #0c9cdb !important;
}

.reply {
  margin-left: 15px;
  color: #0c9cdb;
}

.content {
  color: #20b32d;
  margin-left: 6px;
  max-width: 500px;
  overflow: hidden;
  /*超过部分不显示*/
  text-overflow: ellipsis;
  /*超过部分用点点表示*/
  white-space: nowrap;
  /*不换行*/
}

.createTime {
  font-size: 10px;
  color: #999;
  margin: 2px 6px;
  float: left;
}
</style>
